module.exports = __webpack_public_path__ + "img/icon1.d0ffb869.svg";